import Head from 'next/head'
import { useEffect, useCallback } from 'react'
import { Row, Col, Grid } from 'antd'
import { useRouter } from 'next/router'
import useTranslation from '../../../hooks/useTranslation'
import { useDispatch, useSelector } from 'react-redux'
import { getAllRequests } from '../../../redux/requestSlice'
import { setDashboardTitle } from '../../../redux/themeSlice'

import Layout from '../../../components/layout-components/dashboardLayout/Layout'
import Table from './Table'
import Pagination from '../../../components/shared-components/Pagination'
import RangePicker from '../../../components/shared-components/form/RangePicker'
import SelectServices from '../../../components/shared-components/form/SelectServices'
import SelectStatus from '../../../components/shared-components/form/SelectStatus'
import RequestsCards from '../../../features/CAFRequests/components/RequestsCards'

const { useBreakpoint } = Grid

const Requests = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const router = useRouter()
  
  useEffect(() => {
    dispatch(setDashboardTitle('sidenav.Requests'))
  }, [dispatch])

  const screens = useBreakpoint()

  const { loading, requests, pagination } = useSelector(
    (state) => state.request
  )

  // FILTER HANDLERS
  const onDateChange = useCallback(
    (rangeString) => {
      router.replace({
        query: {
          ...router.query,
          from_date: rangeString[0],
          to_date: rangeString[1],
        },
      })
    },
    [router]
  )

  const onServiceChange = useCallback(
    (val) => {
      router.replace({
        query: { ...router.query, service_id: val },
      })
    },
    [router]
  )

  const onStatusChange = useCallback(
    (val) => {
      router.replace({
        query: { ...router.query, status: val },
      })
    },
    [router]
  )

  const { page, from_date, to_date, service_id, status } = router.query

  useEffect(() => {
    dispatch(getAllRequests({ page, from_date, to_date, service_id, status }))
  }, [dispatch, page, from_date, to_date, service_id, status])

  return (
    <>
      <Head>
        <title>Smartcaf - {t('sidenav.Requests')}</title>
        <link rel='icon' href='/favicon.ico' />
        <meta
          name='description'
          content='Evita le code, siamo il primo CAF in Italia completamente online!'
        />
      </Head>

      <div className='px-16 md:px-34 py-16 md:py-32'>
        <div className='table-filters mb-24'>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8}>
              <RangePicker onChange={onDateChange} />
            </Col>
            <Col xs={24} sm={12} md={8}>
              <SelectServices onChange={onServiceChange} allExist={true} />
            </Col>
            <Col xs={24} sm={12} md={8}>
              <SelectStatus onChange={onStatusChange} />
            </Col>
          </Row>
        </div>

        {screens.xs || (screens.sm && !screens.md) ? (
          <RequestsCards {...{ loading, requests }} />
        ) : (
          <Table {...{ loading, requests }} />
        )}

        <Pagination
          current={pagination?.current}
          from={pagination?.from}
          to={pagination?.to}
          total={pagination?.total}
          last={pagination?.last}
        />
      </div>
    </>
  )
}

Requests.Layout = Layout
export default Requests
